import o from "./index892.js";
import e from "./index813.js";
import i from "./index795.js";
var t = o ? o.isConcatSpreadable : void 0;
function s(r) {
  return i(r) || e(r) || !!(t && r && r[t]);
}
export {
  s as default
};
